import { Button } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

type Props = {
  onActionExportar: (IdArquivoModulo: number, NomeArquivo: string) => void,
};

export const GeneratePrincipalDocColumns = ({
  onActionExportar,
}: Props): GridColDef[] => {
  return [
    {
      field: "NomeArquivo",
      filterable: false,
      headerName: "Nome Arquivo",
      flex: 1,
      minWidth: 120,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "Exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      valueGetter: (_, row) => {
        return row["IdArquivoModulo"] as number;
      },
      renderCell: ({ value, row }) => {
        return (
          <Button
            onMouseDown={(e) => onActionExportar(value, row.NomeArquivo)}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".2rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
            }}
          >
            Exportar
          </Button>
        );
      },
    },
  ];
}